export default "__VITE_ASSET__CfvAATAe__"